import { graphql, useStaticQuery } from 'gatsby';

import { parseStoryblokContent } from './parse-storyblok-content';

export function useSocialLinks() {
  const { socialLinks } = useStaticQuery(graphql`
    query {
      socialLinks: storyblokEntry(field_component: { eq: "socialLinks" }) {
        id
        name
        uuid
        field_component
        content
      }
    }
  `);

  return parseStoryblokContent(socialLinks);
}
